import { render } from "./Error.vue?vue&type=template&id=45adf217&lang=pug"
import script from "./Error.vue?vue&type=script&lang=js"
export * from "./Error.vue?vue&type=script&lang=js"

import exportComponent from "C:\\work\\projects\\phpstorm\\amerika\\jobs\\public_html\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__